import 'helpers/sentry';
import { publish, AGENT_LOADED } from 'helpers/pubsub';
import { clearFavouritesStore, clearInspirationsStore } from 'list/helpers/store';
import { initializeOptimizely } from 'helpers/optimizely';
import { country, language } from 'utils/settings';
import initPublicApi from 'public-api/init';
import { initInspirationsRemoved } from 'apps/InspirationsRemoved/initInspirationsRemoved';
import { initInspirationsPubsubApi } from 'apps/InspirationsPubsubApi';
import { initRemoveFromList } from 'apps/RemoveFromListModal/initRemoveFromList';
import { initAddToList } from 'apps/AddToListModal/initAddToList';

export function init() {
    if (!window.ikea) {
        throw Error('Favs-Agent: window.ikea is missing');
    }
    initPublicApi();
    /**
     *  When a user leaves certain pages we need to clear the store, since it likely contains outdated information.
     * Example pages:
     *  - the login page, where another account might now be used
     */
    const clearStorePaths = [`/${country}/${language}/profile`, `/${country}/${language}/login`];
    if (clearStorePaths.some(path => window.location.pathname.includes(path))) {
        window.addEventListener('beforeunload', function () {
            clearInspirationsStore();
            clearFavouritesStore();
        });
    }
    initializeOptimizely();
    initInspirationsRemoved();
    initAddToList();
    initRemoveFromList();
    initInspirationsPubsubApi();
    publish(AGENT_LOADED, null);
}

try {
    init();
} catch (e) {
    throw Error('Favs-agent: Can´t render AgentModal');
}
